<template>
  <div>
    <!-- <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/about">
          <v-list-item-action>
            <v-icon>mdi-information</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>About Us</v-list-item-title>
          </v-list-item-content>
        </v-list-item>        
        <v-list-item link to="/contact">
          <v-list-item-action>
            <v-icon>mdi-email</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer> -->

    <!-- <v-app-bar
      app
      color="#0b5b9e"
      dark
    > -->
    <v-app-bar
      app
      color="black"
      dark
    >
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <!-- <v-toolbar-title>DMEComply</v-toolbar-title> -->
      <v-toolbar-items>
        <v-btn text link to="/">DMEComply</v-btn>
      </v-toolbar-items>  
      <v-spacer></v-spacer>    
      <v-toolbar-items>
        <v-btn text link to="/about">About</v-btn>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-btn text link to="/contact">Contact</v-btn>
      </v-toolbar-items>      
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data: () => ({
    drawer: null,
  }),  
}
</script>